"use strict";
/**
 * @module Features.Security
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implementation of {@link SessionPropertyValidation}
 *
 * @inheritdoc
 */
var SessionPropertyValidationImpl = /** @class */ (function () {
    /**
     * Create a SessionPropertyValidationImpl instance
     *
     * @param  type   the type of validation
     */
    function SessionPropertyValidationImpl(type) {
        this.type = type;
    }
    return SessionPropertyValidationImpl;
}());
exports.SessionPropertyValidationImpl = SessionPropertyValidationImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/security/session-property-validation.js
// module id = 812
// module chunks = 1